import { useRouteError, isRouteErrorResponse, useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";

const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  // Log to Sentry
  if (error instanceof Error) {
    Sentry.captureException(error);
  } else if (isRouteErrorResponse(error)) {
    Sentry.captureException(new Error(`Route Error: ${error.status} ${error.statusText}`));
  }

  let errorMessage = "An unexpected error occurred";
  let errorStatus = 500;

  if (isRouteErrorResponse(error)) {
    errorStatus = error.status;
    errorMessage = error.statusText || `Error ${error.status}`;
    
    if (error.status === 404) {
      errorMessage = "Page not found";
    }
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-grey-90">
      <div className="text-center px-4">
        <h1 className="text-4xl font-bold text-white mb-4">
          {errorStatus === 404 ? "404" : "Oops!"}
        </h1>
        <p className="text-xl text-white mb-8">{errorMessage}</p>
        <div className="space-x-4">
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-2 bg-white text-grey-90 rounded hover:bg-grey-20 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={() => navigate("/")}
            className="px-6 py-2 bg-white text-grey-90 rounded hover:bg-grey-20 transition-colors"
          >
            Go Home
          </button>
        </div>
        {process.env.NODE_ENV === "development" && error instanceof Error && (
          <details className="mt-8 text-left max-w-2xl mx-auto">
            <summary className="text-white cursor-pointer mb-2">Error Details (Dev Only)</summary>
            <pre className="bg-grey-80 p-4 rounded text-sm text-white overflow-auto">
              {error.stack || error.toString()}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
};

export default ErrorPage;

